import {
  CURRENCY_ISO,
  DEFAULT_FRACTION_DIGITS,
  ENGLISH_LOCALE_CODE,
  FALLBACK_DECIMAL_SEPARATOR,
  FALLBACK_THOUSAND_SEPARATOR,
  WEIGHT_DECIMAL_DIGITS,
} from "./constants";

export class NumberFormatter extends Intl.NumberFormat {
  constructor(locales?: string | string[], options?: Intl.NumberFormatOptions) {
    super(locales, options);
  }

  static getDecimalSeparator(): string {
    if (window.SCHA.config.decimalSeparator) {
      return window.SCHA.config.decimalSeparator;
    }
    return FALLBACK_DECIMAL_SEPARATOR;
  }

  static getThousandSeparator(): string {
    if (window.SCHA.config.thousandSeparator) {
      return window.SCHA.config.thousandSeparator;
    }
    return FALLBACK_THOUSAND_SEPARATOR;
  }

  static getFractionDigits = (currencyCode: string | null) => {
    if (currencyCode === window.SCHA.config.currencyIso) {
      return window.SCHA.config.currencyDecimalDigits;
    }
    return DEFAULT_FRACTION_DIGITS;
  };

  static getFormatter(config?: Intl.NumberFormatOptions) {
    return new NumberFormatter(ENGLISH_LOCALE_CODE, config) as NumberFormatter;
  }

  static getDefaultFormatter(): NumberFormatter {
    return new NumberFormatter(ENGLISH_LOCALE_CODE, {
      maximumFractionDigits: DEFAULT_FRACTION_DIGITS,
    }) as NumberFormatter;
  }

  static getPriceFormatter(): NumberFormatter {
    const fractionDigits = NumberFormatter.getFractionDigits(CURRENCY_ISO);
    return new NumberFormatter(ENGLISH_LOCALE_CODE, {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }) as NumberFormatter;
  }

  static getWeightFormatterKg() {
    return new NumberFormatter(ENGLISH_LOCALE_CODE, {
      minimumFractionDigits: WEIGHT_DECIMAL_DIGITS,
      maximumFractionDigits: WEIGHT_DECIMAL_DIGITS,
    }) as NumberFormatter;
  }

  static getWeightFormatterG() {
    // SCHAEFF-15861 - Grams should be shown without decimals
    return new NumberFormatter(ENGLISH_LOCALE_CODE, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }) as NumberFormatter;
  }

  public format(value: number): string {
    return super
      .format(value)
      .replaceAll(",", "#")
      .replaceAll(".", "?")
      .replaceAll("#", NumberFormatter.getThousandSeparator())
      .replaceAll("?", NumberFormatter.getDecimalSeparator());
  }
}
